import { useContext } from "react";
import { PermissionContext } from "../../../utils/context";
import { getGenerateProgress } from "../../../utils/net";
import * as Sentry from "@sentry/react";
let fakeProgressTimer = null

const fakeProgressBar = (setGeneratePercentage, secs = 10, initvalue = 90) => {
    new Promise((resolve) => {
        const interval = secs * 1000 / 40;
        const maxvalue = initvalue ? initvalue >= 90 ? 90 : initvalue : 90
        fakeProgressTimer = setInterval(() => {
            setGeneratePercentage(prevPercentage => {
                const fluctuation = Math.random() * 8
                const nextPercentage = prevPercentage + Math.floor(fluctuation);
                if (nextPercentage >= maxvalue) {
                    clearInterval(fakeProgressTimer);
                    resolve();
                    return maxvalue;
                }
                return nextPercentage;
            });
        }, interval);
    });
};

const startFakeProgressBar = (setGeneratePercentage, secs, initvalue) => {
    if (fakeProgressTimer) {
        clearInterval(fakeProgressTimer);
    }
    fakeProgressBar(setGeneratePercentage, secs, initvalue);
};

const doneFakeProgressBar = (setGeneratePercentage, value = 100) => {
    clearInterval(fakeProgressTimer);
    setGeneratePercentage(value);
}

const checkProgressUntilDone = (uuid) => {
    return new Promise((resolve) => {
        const intervalId = setInterval(async () => {
            try {
                const progress = await getGenerateProgress(uuid);

                if (progress.data.stage === 'Done') {
                    clearInterval(intervalId);
                    resolve(progress);
                }

                if (progress.data.stage === 'Canceled') {
                    clearInterval(intervalId);
                    resolve('Canceled')
                }

            } catch (error) {
                Sentry.captureException(error)
                // clearInterval(intervalId);
                // reject(error);
                console.error("Err during progress check")
            }
        }, 1000);
    });
};

const fetchSettings = async ({ settings }) => {
    const settingsResponse = await fetch(settings);
    if (!settingsResponse.ok) {
        throw new Error(`HTTP error! status: ${settingsResponse.status}`);
    }
    return await settingsResponse.json()
}

export const getCurrentUserTotalRedoCount = (subscriptionsInfo, module, isLimitEnabled) => {
    if (!isLimitEnabled) {
        return Infinity;
    }
    if (module === "GEO") {
        if (['Creator', 'Education'].includes(subscriptionsInfo.plan_level)) {
            return 20
        } else if (['Enterprise', 'Unlimited', 'Business'].includes(subscriptionsInfo.plan_level)) {
            return 50
        } else {
            return 10
        }
    } else {
        if (['Creator', 'Education'].includes(subscriptionsInfo.plan_level)) {
            return 6
        } else if (['Enterprise', 'Unlimited', 'Business'].includes(subscriptionsInfo.plan_level)) {
            return 15
        } else {
            return 3
        }
    }
}


export { fakeProgressBar, startFakeProgressBar, checkProgressUntilDone, fetchSettings, doneFakeProgressBar }